module.exports = __webpack_public_path__ + "media/images/avatar-1-05ea2e5f80d8cc6c217f3d5d5c2dc46e.png";